<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/client">Clientes</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Atualizar Dados gerais / {{ client.name }}</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <tabMenuClient :id="client.id" :type="client.type"></tabMenuClient>
                <div class="tab-content">
                    <div class="tab-pane active" role="tabpanel" id="info">
                        <div class="card shadow mb-4">

                            <!-- Card Header - Dropdown -->
                            <div class="card-body">
                                <form @submit="update">
                                    <fieldset>
                                        <legend>Dados gerais</legend>

                                        <div class="row mt-2">
                                            <div class="col-xl-2 col-md-2 col-sm-12">
                                                <label for="">Matrícula</label>
                                                <div class="input-group mb-3">
                                                    <input type="text" class="form-control" placeholder="Ex: 1"
                                                        v-model="client.mat">
                                                </div>
                                            </div>
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">CNPJ*</label>
                                                <div class="input-group mb-3">
                                                    <input type="text" class="form-control"
                                                        placeholder="Ex: xx.xxx.xxx/xxxx-xx" v-model="client.document"
                                                        v-mask="['##.###.###/####-##']" @keypress="enableSearchCnpj()">
                                                    <div class="input-group-append">
                                                        <button class="btn btn-success" type="button" id="button-addon2"
                                                            :disabled="searchCnpj" @click="searchCNPJ()"><i
                                                                class="fa fa-search"></i>Buscar
                                                            CNPJ</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xl-6 col-md-6 col-sm-12">
                                                <label for="">Razão Social*</label>
                                                <input type="text" class="form-control" placeholder="Ex: Empresa XYZ"
                                                    v-model="client.name">
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">Nome Fantasia</label>
                                                <input type="text" class="form-control" placeholder="Ex: Empresa XYZ"
                                                    v-model="client.name_fantasy">
                                            </div>
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">NIRE</label>
                                                <input type="text" class="form-control" placeholder="Ex: #####"
                                                    v-model="client.nire">
                                            </div>
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">CCMEI</label>
                                                <input type="text" class="form-control" v-model="client.ccmei"
                                                    placeholder="Ex: ######">
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-xl-6 col-md-6 col-sm-12">
                                                <label for="">E-mail</label>
                                                <input type="text" class="form-control"
                                                    placeholder="Ex: usuario@dominio.com" v-model="client.email">
                                            </div>
                                            <div class="col-xl-6 col-md-6 col-sm-12">
                                                <label for="">Telefone*</label>
                                                <input type="text" class="form-control" v-model="client.phone"
                                                    v-mask="['(##) ####-####', '(##) #####-####']"
                                                    placeholder="(xx)x.xxxx-xxxx">
                                            </div>
                                        </div>
                                    </fieldset>
                                    <fieldset class="mt-3">
                                        <legend>Endereço CNPJ</legend>
                                        <div class="row">
                                            <div class="col-xl-3 col-md-3 col-sm-12">
                                                <label for="">CEP</label>
                                                <div class="input-group mb-3">
                                                    <input type="text" class="form-control" placeholder="Ex: xxxxx-xxx"
                                                        v-model="client.zipcode" v-mask="['#####-###']">
                                                    <div class="input-group-append">
                                                        <button class="btn btn-success" type="button" id="button-addon2"
                                                            @click="searchZipcode()"><i class="fa fa-search"></i>Buscar
                                                            CEP</button>
                                                    </div>

                                                </div>
                                            </div>
                                            <div class="col-xl-7 col-md-7 col-sm-12">
                                                <label for="">Endereço*</label>
                                                <input type="text" class="form-control" placeholder="Ex: Av. Paulista"
                                                    v-model="client.street">
                                            </div>
                                            <div class="col-xl-2 col-md-2 col-sm-12">
                                                <label for="">Nº</label>
                                                <input type="text" class="form-control" placeholder="Ex: 100"
                                                    v-model="client.number_street">
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-xl-12 col-md-12 col-sm-12">
                                                <label for="">Complemento</label>
                                                <input type="text" class="form-control" placeholder="Ex: Próximo à...."
                                                    v-model="client.complement">
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">Bairro</label>
                                                <input type="text" class="form-control" placeholder="Ex: Centro"
                                                    v-model="client.district">
                                            </div>
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">Cidade</label>
                                                <input type="text" class="form-control" placeholder="Ex: São Paulo"
                                                    v-model="client.city">
                                            </div>
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">UF</label>
                                                <input type="text" class="form-control" placeholder="Ex: SP"
                                                    v-model="client.uf">
                                            </div>
                                        </div>
                                    </fieldset>
                                    <fieldset>
                                        <legend>Observações</legend>
                                        <div class="row mt- mb-4">
                                            <div class="col-lg-12 col-xs-12 col-sm-12">
                                                <editorText @update-text="updateObservation"
                                                    :modelValue="client.observation" placeholderSend="Sem observações"
                                                    ref="myChild">
                                                </editorText>
                                            </div>
                                        </div>
                                        <br>
                                    </fieldset>
                                    <br>
                                    <div class="row">
                                        <div class="col-xl-12 col-md-12 col-sm-12">
                                            <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                                    class="fa fa-save"></i> Atualizar</button>
                                            <router-link to="/client" class="btn btn-danger ml-3"><i
                                                    class="fa fa-times"></i>
                                                Cancelar</router-link>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import editorText from '../util/editor-text.vue';
import tabMenuClient from './tab-menu-client.vue';
import { getCNPJ, getCNPJAlternative } from '@/api-external';
import { capitalize, maskPhone } from '@/util';
import { mask } from 'vue-the-mask'

export default {
    directives: { mask },
    components: { Loading, editorText, tabMenuClient },
    data() {
        return {
            isLoading: true,
            fullPage: true,

            gender_multiselect: '',
            client: {
                mat: '',
                document: '',
                name: '',
                name_fantasy: '',
                phone: '',
                email: '',
                nire: '',
                ccmei: '',
                zipcode: '',
                street: '',
                number_street: '',
                complement: '',
                district: '',
                city: '',
                uf: '',
            },
            enable_error_list: false,
            errors: []
        }
    },

    computed: {
        isDisabled: function () {
            return this.client.document != '' && this.client.name != '' && this.client.phone != '';
        }
    },
    mounted() {
        this.isLoading = false;
        this.getclient();
    },
    beforeMount() {
        const id = this.$route.params.id;
        this.client.id = id;
    },
    methods: {
        onCancel() { },
        handleSelect(option) {
            this.client.gender = option.type;
        },
        sexoWithLang({ value }) {
            return value;
        },

        async getclient() {
            const response = await api.get('/client/' + this.client.id)
                .then((response) => {
                    this.isLoading = false;
                    this.client = response.data.client;
                    this.client.document = response.data.client.document_formatted;
                    this.client.phone = response.data.client.phone_formatted;
                    this.$refs.myChild.updateTextEditor(this.client.observation);

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                });
            return response;

        },
        enableSearchCnpj() {
            this.searchCnpj = true;
            if (this.client.document.length > 0) {
                let cnpj = this.client.document.replace(/\D/g, '');
                if (cnpj.length == 13) {
                    this.searchCnpj = false;
                }
            }
        },
        searchCNPJ() {
            this.isLoading = true;
            if (this.client.document.length > 0) {
                let cnpj = this.client.document.replace(/\D/g, '');
                getCNPJ(cnpj).then((response) => {
                    this.client.name = capitalize(response.razao_social);
                    this.client.phone = response.ddd_telefone_1 ? maskPhone(response.ddd_telefone_1) : '';
                    this.client.email = response.email ? response.email : '';
                    this.client.street = response.logradouro ? capitalize(response.logradouro) : '';
                    this.client.street = response.logradouro ? capitalize(response.logradouro) : '';
                    this.client.district = response.bairro ? capitalize(response.bairro) : '';
                    this.client.city = response.municipio ? capitalize(response.municipio) : '';
                    this.client.uf = response.uf ? capitalize(response.uf) : '';
                    this.isLoading = false;
                    if (this.client.email == '') {
                        getCNPJAlternative(cnpj).then((response) => {
                            this.client.email = response.email ? response.email.toLowerCase() : '';
                            this.client.number_street = response.numero ? response.numero : '';
                            this.client.name_fantasy = response.nome_fantasia ? capitalize(response.nome_fantasia) : '';
                        }).catch(() => {
                            this.isLoading = false;
                        });
                    }
                }).catch(() => {
                    this.isLoading = false;
                });
            }
        },

        updateObservation(observation) {
            this.client.observation = observation;
        },

        update(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            api.put('/client/' + this.client.id, this.client)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Cliente atualizado com sucesso!",
                        type: 'success'
                    });
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status);
                })

        }
    }
}
</script>

<style lang="scss" scoped></style>